/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@ukic/web-components/loader';
defineCustomElements();
export var IcAccordion = /*@__PURE__*/ createReactComponent('ic-accordion');
export var IcAccordionGroup = /*@__PURE__*/ createReactComponent('ic-accordion-group');
export var IcAlert = /*@__PURE__*/ createReactComponent('ic-alert');
export var IcBackToTop = /*@__PURE__*/ createReactComponent('ic-back-to-top');
export var IcBadge = /*@__PURE__*/ createReactComponent('ic-badge');
export var IcBreadcrumb = /*@__PURE__*/ createReactComponent('ic-breadcrumb');
export var IcBreadcrumbGroup = /*@__PURE__*/ createReactComponent('ic-breadcrumb-group');
export var IcButton = /*@__PURE__*/ createReactComponent('ic-button');
export var IcCard = /*@__PURE__*/ createReactComponent('ic-card');
export var IcCheckbox = /*@__PURE__*/ createReactComponent('ic-checkbox');
export var IcCheckboxGroup = /*@__PURE__*/ createReactComponent('ic-checkbox-group');
export var IcChip = /*@__PURE__*/ createReactComponent('ic-chip');
export var IcClassificationBanner = /*@__PURE__*/ createReactComponent('ic-classification-banner');
export var IcDataEntity = /*@__PURE__*/ createReactComponent('ic-data-entity');
export var IcDataRow = /*@__PURE__*/ createReactComponent('ic-data-row');
export var IcDialog = /*@__PURE__*/ createReactComponent('ic-dialog');
export var IcDivider = /*@__PURE__*/ createReactComponent('ic-divider');
export var IcEmptyState = /*@__PURE__*/ createReactComponent('ic-empty-state');
export var IcFooter = /*@__PURE__*/ createReactComponent('ic-footer');
export var IcFooterLink = /*@__PURE__*/ createReactComponent('ic-footer-link');
export var IcFooterLinkGroup = /*@__PURE__*/ createReactComponent('ic-footer-link-group');
export var IcHero = /*@__PURE__*/ createReactComponent('ic-hero');
export var IcHorizontalScroll = /*@__PURE__*/ createReactComponent('ic-horizontal-scroll');
export var IcInputComponentContainer = /*@__PURE__*/ createReactComponent('ic-input-component-container');
export var IcInputContainer = /*@__PURE__*/ createReactComponent('ic-input-container');
export var IcInputLabel = /*@__PURE__*/ createReactComponent('ic-input-label');
export var IcInputValidation = /*@__PURE__*/ createReactComponent('ic-input-validation');
export var IcLink = /*@__PURE__*/ createReactComponent('ic-link');
export var IcLoadingIndicator = /*@__PURE__*/ createReactComponent('ic-loading-indicator');
export var IcMenu = /*@__PURE__*/ createReactComponent('ic-menu');
export var IcMenuGroup = /*@__PURE__*/ createReactComponent('ic-menu-group');
export var IcMenuItem = /*@__PURE__*/ createReactComponent('ic-menu-item');
export var IcNavigationButton = /*@__PURE__*/ createReactComponent('ic-navigation-button');
export var IcNavigationGroup = /*@__PURE__*/ createReactComponent('ic-navigation-group');
export var IcNavigationItem = /*@__PURE__*/ createReactComponent('ic-navigation-item');
export var IcNavigationMenu = /*@__PURE__*/ createReactComponent('ic-navigation-menu');
export var IcPageHeader = /*@__PURE__*/ createReactComponent('ic-page-header');
export var IcPagination = /*@__PURE__*/ createReactComponent('ic-pagination');
export var IcPaginationItem = /*@__PURE__*/ createReactComponent('ic-pagination-item');
export var IcPopoverMenu = /*@__PURE__*/ createReactComponent('ic-popover-menu');
export var IcRadioGroup = /*@__PURE__*/ createReactComponent('ic-radio-group');
export var IcRadioOption = /*@__PURE__*/ createReactComponent('ic-radio-option');
export var IcSearchBar = /*@__PURE__*/ createReactComponent('ic-search-bar');
export var IcSectionContainer = /*@__PURE__*/ createReactComponent('ic-section-container');
export var IcSelect = /*@__PURE__*/ createReactComponent('ic-select');
export var IcSideNavigation = /*@__PURE__*/ createReactComponent('ic-side-navigation');
export var IcSkeleton = /*@__PURE__*/ createReactComponent('ic-skeleton');
export var IcStatusTag = /*@__PURE__*/ createReactComponent('ic-status-tag');
export var IcStep = /*@__PURE__*/ createReactComponent('ic-step');
export var IcStepper = /*@__PURE__*/ createReactComponent('ic-stepper');
export var IcSwitch = /*@__PURE__*/ createReactComponent('ic-switch');
export var IcTab = /*@__PURE__*/ createReactComponent('ic-tab');
export var IcTabContext = /*@__PURE__*/ createReactComponent('ic-tab-context');
export var IcTabGroup = /*@__PURE__*/ createReactComponent('ic-tab-group');
export var IcTabPanel = /*@__PURE__*/ createReactComponent('ic-tab-panel');
export var IcTextField = /*@__PURE__*/ createReactComponent('ic-text-field');
export var IcTheme = /*@__PURE__*/ createReactComponent('ic-theme');
export var IcToast = /*@__PURE__*/ createReactComponent('ic-toast');
export var IcToastRegion = /*@__PURE__*/ createReactComponent('ic-toast-region');
export var IcToggleButton = /*@__PURE__*/ createReactComponent('ic-toggle-button');
export var IcToggleButtonGroup = /*@__PURE__*/ createReactComponent('ic-toggle-button-group');
export var IcTooltip = /*@__PURE__*/ createReactComponent('ic-tooltip');
export var IcTopNavigation = /*@__PURE__*/ createReactComponent('ic-top-navigation');
export var IcTypography = /*@__PURE__*/ createReactComponent('ic-typography');
